import {call, put, takeLatest, fork, all, delay,} from 'redux-saga/effects';
import * as Types from '../constants/Types';
import * as VinWonderTicketService from './../services/vinWonderTicketService';

import i18n from '../constants/initLng';
import * as Func from "../helpers/functions";
import {PATHS, SAGA_DELAY_TIMEOUT} from '../constants/Define';
import { parseListRequestParamsCameo } from '../utils/commonUtils';
import {
    setListVinWonderTickets as setListVinWonderTicketsAction,
    setVinWonderTicketDetail as setVinWonderTicketDetailAction,
    setVinWonderTicketItemDetail as setVinWonderTicketItemDetailAction,
    setListRef
} from './../actions/vinWonderTicketAction';
import history from './../helpers/history';

function* getListVinWonderTicket() {
    yield takeLatest(Types.VIN_WONDER_TICKET_LIST_ACTION, Func.sagaWrapper(function* (action) {
        const params = parseListRequestParamsCameo(action.filters || {})
        yield delay(SAGA_DELAY_TIMEOUT);
        const result = yield call(VinWonderTicketService.getVinWonderTicket, params);
        yield put(setListVinWonderTicketsAction(result));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_LIST_FAIL)))
}

function* getVinWonderTicketDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTicketService.getVinWonderTicketDetail, action.id);
        yield put(setVinWonderTicketDetailAction(result));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* updateVinWonderTicketDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderTicketService.updateVinWonderTicketDetail, action.vinWonderTicket.vinWonderTicket);
        successHandleVinWonderTicket(action, action.vinWonderTicket.vinWonderTicket.name);
        yield put(setVinWonderTicketDetailAction(action.vinWonderTicket.vinWonderTicket));
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_TICKET.LIST.path, { vin_wonder_id: action.vinWonderTicket.vinWonderTicket.vinWonderId })
        history.push(path);
        history.go();
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* createVinWonderTicketDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(VinWonderTicketService.createVinWonderTicketDetail, action.vinWonderTicket);
        successHandleVinWonderTicket(action, action.vinWonderTicket.name);
        yield put(setVinWonderTicketDetailAction(result));
        const path = Func.getPathWithParams(PATHS.VIN_WONDER_TICKET.LIST.path, { vin_wonder_id: action.vinWonderTicket.vinWonderId })
        history.push(path);
        history.go();
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* deleteVinWonderTicketDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderTicketService.deleteVinWonderTicketDetail, action.vinWonderTicket);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        const params = parseListRequestParamsCameo(action.filters || {});
        params.filters.vinWonderId = action.vinWonderTicket.vinWonderId;
        const resultList = yield call(VinWonderTicketService.getVinWonderTicket, params.filters);
        yield put(setListVinWonderTicketsAction(resultList));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)));
}

function* getListRef() {
    yield takeLatest(Types.VIN_WONDER_GET_ALL_REF, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTicketService.getListRef, action.data);
        yield put(setListRef(result.data.data));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_GET_ALL_REF_FAIL)))
}

function* getVinWonderTicketItemDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_ITEM_DETAIL_ACTION, Func.sagaWrapper(function* (action) {
        const result = yield call(VinWonderTicketService.getVinWonderTicketItemDetail, action.id);
        yield put(setVinWonderTicketItemDetailAction(result));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* updateVinWonderTicketItemDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_ITEM_DETAIL_UPDATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderTicketService.updateVinWonderTicketItemDetail, action.vinWonderTicketItem.vinWonderTicketItem);
        successHandleVinWonderTicket(action, action.vinWonderTicketItem.vinWonderTicketItem.ticketType);
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicketItem.vinWonderTicketItem.vinWonderTicketId });
        yield put(setVinWonderTicketItemDetailAction(action.vinWonderTicketItem.vinWonderTicketItem));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* createVinWonderTicketItemDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_ITEM_DETAIL_CREATE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        const result = yield call(VinWonderTicketService.createVinWonderTicketItemDetail, action.vinWonderTicketItem);
        successHandleVinWonderTicket(action, action.vinWonderTicketItem.ticketType);
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicketItem.vinWonderTicketId });
        yield put(setVinWonderTicketItemDetailAction(result));
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)))
}

function* deleteVinWonderTicketItemDetail() {
    yield takeLatest(Types.VIN_WONDER_TICKET_ITEM_DETAIL_DELETE_ACTION, Func.sagaWrapper(function* (action) {
        Func.sagaLoadingMessage(action);
        yield call(VinWonderTicketService.deleteVinWonderTicketItemDetail, action.vinWonderTicketItem);
        Func.sagaSuccessMessage({
            action,
            message: `${i18n.t('notification.removeSuccess')}`,
        });
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicketItem.vinWonderTicketId });
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_DETAIL_FAIL)));
}


/* Transtale Saga */

function* createVinWonderTicketTranslate() {
    yield takeLatest(Types.VIN_WONDER_TICKET_CREATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTicketService.createVinWonderTicketTranslate, action.vinWonderTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.201'), action.vinWonderTicket.translate.languageName);
        yield put({ type: Types.VIN_WONDER_TICKET_CREATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicket.id });
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_FAIL)))
}

function* updateVinWonderTicketTranslate() {
    yield takeLatest(Types.VIN_WONDER_TICKET_UPDATE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTicketService.updateVinWonderTicketTranslate, action.vinWonderTicket);
        Func.sagaSuccessMessage(action, i18n.t('validation.statusCode.code.204'), action.vinWonderTicket.translate.languageName);
        yield put({ type: Types.VIN_WONDER_TICKET_UPDATE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicket.id });
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_FAIL)))
}

function* deleteVinWonderTicketTranslate() {
    yield takeLatest(Types.VIN_WONDER_TICKET_DELETE_TRANSLATE_ACTION, Func.sagaWrapper(function* (action) {
        yield call(VinWonderTicketService.deleteVinWonderTicketTranslate, action.vinWonderTicket.translate.id);
        Func.sagaSuccessMessage(action, i18n.t('notification.removeSuccess'), action.vinWonderTicket.translate.languageName);
        yield put({ type: Types.VIN_WONDER_TICKET_DELETE_TRANSLATE_SUCCESS });
        yield put({ type: Types.VIN_WONDER_TICKET_DETAIL_ACTION, id: action.vinWonderTicket.id });
    }, errorHandleVinWonderTicket(Types.VIN_WONDER_TICKET_FAIL)))
}

function successHandleVinWonderTicket(action, value) {
    return Func.sagaSuccessMessage({
        action,
        message: `${i18n.t('notification.createSuccess')}`,
        description: `${i18n.t('item.vinWonderTickets.title')} "${value}"`
    })
}


function errorHandleVinWonderTicket(errorActionType) {
    return Func.sagaErrorHandler(function* (e) {
        yield put({ type: errorActionType })
    }, 'vinWonderTickets');
}

export function* VinWonderTicketSaga() {
    yield all([
        fork(getListVinWonderTicket),
        fork(getVinWonderTicketDetail),
        fork(updateVinWonderTicketDetail),
        fork(createVinWonderTicketDetail),
        fork(getListRef),
        fork(getVinWonderTicketItemDetail),
        fork(updateVinWonderTicketItemDetail),
        fork(createVinWonderTicketItemDetail),
        fork(createVinWonderTicketTranslate),
        fork(updateVinWonderTicketTranslate),
        fork(deleteVinWonderTicketDetail),
        fork(deleteVinWonderTicketItemDetail),
        fork(deleteVinWonderTicketTranslate)
    ])
}
